const vocab = {
  language: {
    ar: 'العربية (ar)',
    bg: 'Български (bg)',
    bs: 'bosanski (bs)',
    cs: 'čeština (cs)',
    da: 'dansk (da)',
    de: 'Deutsch (de)',
    el: 'ελληνικά (el)',
    en: 'English (en)',
    es: 'Español (es)',
    et: 'eesti (et)',
    fi: 'Suomi (fi)',
    fr: 'Français (fr)',
    ga: 'Gaeilge (ga)',
    hr: 'Hrvatski (hr)',
    hu: 'magyar (hu)',
    is: 'Íslenska (is)',
    it: 'italiano (it)',
    lt: 'lietuvių (lt)',
    lv: 'Latviešu (lv)',
    mk: 'македонски (mk)',
    mt: 'Malti (mt)',
    nl: 'Nederlands (nl)',
    no: 'Norsk (no)',
    pl: 'polski (pl)',
    pt: 'Português (pt)',
    ro: 'Română (ro)',
    ru: 'русский (ru)',
    sk: 'slovenčina (sk)',
    sl: 'Slovenščina (sl)',
    sq: 'Shqip (sq)',
    sr: 'Српски (sr)',
    sv: 'Svenska (sv)',
    tr: 'Türkçe (tr)',
  },
  cluster_name: {
    eea: 'European Environment Agency',
    fise: 'Forest Information System for Europe',
    bise: 'Biodiversity Information System for Europe',
    industry: 'European Industrial Emissions Portal',
    energy: 'Climate and Energy in the EU',
    cca: 'Climate Adaptation Platform',
    ias: 'Invasive Alien Species',
    'wise-freshwater': 'Freshwater Information System for Europe',
    'wise-marine': 'Marine Water Information System for Europe',
    etc: 'European Environment Information and Observation Network (Eionet)',
    'etc-atni':
      'ETC on Air Pollution, Transport, Noise and Industrial Pollution',
    'etc-bd': 'ETC on Biological Diversity',
    'etc-cca': 'ETC on Climate Change Impacts, Vulnerability and Adaptation',
    'etc-cme': 'ETC on Climate Change Mitigation and Energy',
    'etc-icm': 'ETC on Inland, Coastal and Marine Waters',
    'etc-uls': 'ETC on Urban, Land and Soil Systems',
    'etc-wmge': 'ETC on Waste and Materials in Green Economy',
    sdi: 'Datahub',
    cab: 'Climate Advisory Board',
    discomap: 'DiscoMap',
    noise: 'NOISE Observation & Information Service for Europe',
    copernicus_insitu: 'Copernicus In Situ',
  },
};

const vocabWrapper = { vocab };

export default vocabWrapper;
